import { render, staticRenderFns } from "./SwiperSlider.vue?vue&type=template&id=e2067db4&scoped=true&"
import script from "./SwiperSlider.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SwiperSlider.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SwiperSlider.vue?vue&type=style&index=0&id=e2067db4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2067db4",
  null
  
)

export default component.exports